import React, { useContext } from "react";

import { Transition } from "@headlessui/react";
import { useTranslation } from "react-i18next";

import ConfigContext from "@/components/Config/configContext";
import ConnectionContext from "@/connectionContext";
import constants from "@/utils/constants";

export default function LoanSharkBar() {
  const { t } = useTranslation();
  const { configQuery } = useContext(ConfigContext);
  const { connected } = useContext(ConnectionContext);

  if (
    !location.pathname ||
    location.pathname.includes("/point-of-sale/secondary")
  ) {
    return null;
  }

  return (
    <Transition
      appear={true}
      show={
        !!configQuery?.config?.features?.includes(
          constants.FEATURES.LOAN_SHARK_MODE,
        ) && connected
      }
      className="transition-all"
      enterFrom="opacity-0 -translate-y-8"
      enterTo="opacity-100 translate-y-0 bg-red-500"
      leaveFrom="opacity-100 translate-y-0"
      leaveTo="opacity-0 -translate-y-8"
    >
      <div
        id="subscription_expired_notice"
        className="flex justify-center items-center p-2 w-full font-semibold text-white bg-red-500"
      >
        {t("common.loanShark")}
        <a
          href="/billing"
          target="_blank"
          className="ml-2 text-white underline"
          rel="noreferrer"
        >
          {t("common.loanSharkBilling")}
        </a>
      </div>
    </Transition>
  );
}
